// extracted by mini-css-extract-plugin
export default {"link":"Navigation_link__5kKHa"};